import './Loading.css';

const Loading = () => (
  <div className="no-freeze-spinner" data-testid="generated-prompt-loading">
    <div id="no-freeze-spinner">
      <div>
        <i className="material-icons">directions_car</i>
        <i className="material-icons">auto_fix_high</i>
        <i className="material-icons">dataset</i>
        <div></div>
      </div>
    </div>
  </div>
);

export default Loading;
